export default "__VITE_ASSET__DRYY$QXh__"